const isInactiveSalesRep = salesRep =>
  Boolean(salesRep && salesRep.status && salesRep.status.toLowerCase() !== "active");

const salesRepDataLabelClass = salesRep =>
  isInactiveSalesRep(salesRep) ? "urgent" : undefined;

export { isInactiveSalesRep, salesRepDataLabelClass };
